document.addEventListener('DOMContentLoaded', function () {
  const currentLang = document.documentElement.lang;
  const currentPath = window.location.pathname;
  const languageSwitcher = document.querySelector('.language-switcher');
  const options = languageSwitcher.querySelectorAll('.language-option');

  options.forEach((option) => {
    if (option.dataset.lang === currentLang) {
      option.style.display = 'none';
    } else {
      option.style.display = 'flex';
    }

    if (option.dataset.lang === 'en') {
      option.href = `/en${currentLang === 'nl' ? currentPath : currentPath.replace('/en', '')}`;
    } else if (option.dataset.lang === 'nl') {
      option.href = currentPath.replace('/en', '');
    }
  });
});
